import { Card } from "@/components/ui/card";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { Body } from "@hypercard/web-components";
import { ViewCustomFieldDetails } from "./ViewCustomFieldDetails";
import { useState } from "react";
import {
  CustomFieldEntity,
  useAdminCustomFieldsQuery,
} from "@common/utils/graphql";
import { EditCustomFieldForm } from "./EditCustomFieldForm";
import { CustomFieldsTable } from "./CustomFieldsTables";
import { useMemo } from "react";
import { FullPageLoader } from "@common/components/Loading/FullPageLoading";
import { isListField } from "@common/components/CustomFields";

// The query has state as String instead of CustomFieldEntityState
// Prevent enabling field with no list options
// Change the default custom field types to List
export function CustomFieldsTab() {
  const [viewCustomFieldEntityId, setViewCustomFieldEntityId] = useState<
    number | null
  >(null);
  const { data, loading } = useAdminCustomFieldsQuery();

  const customFields = useMemo(() => {
    return data?.adminCustomFields.__typename ===
      "QueryAdminCustomFieldsSuccess"
      ? data.adminCustomFields.data.customFields
      : [];
  }, [data]);

  const viewCustomFieldDetails = useMemo(() => {
    if (!viewCustomFieldEntityId) return null;
    return (
      customFields.find((field) => field.id === viewCustomFieldEntityId) || null
    );
  }, [viewCustomFieldEntityId, customFields]);

  const handleViewDetails = (field: CustomFieldEntity) => {
    setViewCustomFieldEntityId(field.id);
  };

  return (
    <div className="mt-6 flex w-full grow flex-col">
      <Body size="2xl" weight="medium">
        Custom Fields
      </Body>
      <Body size="md" weight="regular" className="mt-2 text-white/70">
        Enable or disable custom fields for your organization
      </Body>
      {loading && customFields.length === 0 ? (
        <FullPageLoader />
      ) : (
        <Card className="mt-4">
          <CustomFieldsTable
            customFields={customFields}
            onEdit={handleViewDetails}
          />
        </Card>
      )}

      {/* Custom field details sheet */}
      <Sheet open={!!viewCustomFieldDetails}>
        <SheetContent
          onClose={() => setViewCustomFieldEntityId(null)}
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          {viewCustomFieldDetails ? (
            isListField(viewCustomFieldDetails) ? (
              <ViewCustomFieldDetails customField={viewCustomFieldDetails} />
            ) : (
              <EditCustomFieldForm
                customField={viewCustomFieldDetails}
                onClose={() => setViewCustomFieldEntityId(null)}
              />
            )
          ) : null}
        </SheetContent>
      </Sheet>
    </div>
  );
}
